import { render } from "./FullscreenImage.vue?vue&type=template&id=fa0fd41a&scoped=true&ts=true"
import script from "./FullscreenImage.vue?vue&type=script&lang=ts"
export * from "./FullscreenImage.vue?vue&type=script&lang=ts"

import "./FullscreenImage.vue?vue&type=style&index=0&id=fa0fd41a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0fd41a"]])

export default __exports__